import { z } from "zod/v4";

const allowance = z.number().int().nonnegative().nullable();
const windowedLimit = z.object({ limit: allowance, windowHours: z.number().int().positive() });
export const planLimitsSchema = z.object({
  storage: allowance, trips: allowance, membersPerTrip: allowance, eventsPerTrip: allowance,
  ai: windowedLimit, exports: windowedLimit,
  eventImports: z.object({ multi: windowedLimit }),
});
export const capabilitiesSchema = z.object({
  trip: z.object({ import: z.object({ package: z.boolean(), cloudDrive: z.boolean() }), export: z.boolean() }),
  members: z.object({ import: z.object({ bulk: z.boolean() }) }),
  events: z.object({ import: z.object({ email: z.boolean(), direct: z.boolean(), multi: z.boolean() }) }),
  travelDocuments: z.object({ aiAutoFill: z.boolean() }),
});
export const selfPlanSchema = z.object({
  id: z.string().min(1), name: z.string().min(1), legacy: z.boolean(),
  limits: planLimitsSchema, capabilities: capabilitiesSchema,
});
export const publicPlanSchema = selfPlanSchema.extend({ available: z.boolean() });
export const plansSchema = z.array(publicPlanSchema);
export const adminPlanSchema = publicPlanSchema.extend({
  kind: z.enum(["PUBLIC", "LEGACY", "ADMIN"]), visible: z.boolean(),
  limits: planLimitsSchema.extend({ geocoding: windowedLimit }),
});
export const adminPlansSchema = z.array(adminPlanSchema);
export type Plan = z.infer<typeof selfPlanSchema>;
export type PublicPlan = z.infer<typeof publicPlanSchema>;
export type AdminPlan = z.infer<typeof adminPlanSchema>;
